import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getNewsletterSubscriptions = () =>
  axiosInstance.get(`${LANDING_API_URL}/setting/subscribe-newsletter-list`, {
    headers: authHeaders(),
  });

export const createNewsletterSubscriptionRequest = (subscriptionData) =>
  axiosInstance.post(
    `${LANDING_API_URL}/setting/subscribe-newsletter`,
    subscriptionData,
    { headers: authHeaders() },
  );

export const updateNewsletterSubscriptionRequest = (id, subscriptionData) =>
  axiosInstance.post(
    `${LANDING_API_URL}/setting/newsletter-update/${id}`,
    subscriptionData,
    { headers: authHeaders() },
  );

export const removeNewsletterSubscription = (id) =>
  axiosInstance.delete(
    `${LANDING_API_URL}/setting/newsletter-delete/${id}`,
    { headers: authHeaders() },
  );
